<template>
    <div>
      <img
        src="../../assets/img/configH5Video.jpg"
        alt=""
        class="appDownload"
      >
    </div>
  </template>
  
  <script>
  export default {
  
  }
  </script>
  
  <style lang="scss" scoped>
  .appDownload {
    width: 100%;
    height: 100%;
    display: block;
  }
  </style>